import { render } from "./Opponent.vue?vue&type=template&id=a1540732"
import script from "./Opponent.vue?vue&type=script&lang=js"
export * from "./Opponent.vue?vue&type=script&lang=js"

import "./Opponent.vue?vue&type=style&index=0&id=a1540732&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__